import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const EXPENSE_URL = `${API_URL}/expenses`;
const LOV_URL = `${API_URL}/commonLOVs`;
const DEDUCTIONS_URL = `${API_URL}/po-exp-deductions`;

// Get auth token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const expenseService = {
  // Get all expenses with filters
  getAllExpenses: async (filters = {}) => {
    try {
      const response = await axios.get(EXPENSE_URL, {
        headers: getAuthHeader(),
        params: filters
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch expenses' };
    }
  },

  // Get expense by ID
  getExpenseById: async (expenseId) => {
    try {
      const response = await axios.get(`${EXPENSE_URL}/${expenseId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch expense' };
    }
  },

  // Create new expense
  createExpense: async (expenseData) => {
    try {
      const response = await axios.post(EXPENSE_URL, expenseData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create expense' };
    }
  },

  // Update expense
  updateExpense: async (expenseId, expenseData) => {
    try {
      const response = await axios.put(`${EXPENSE_URL}/${expenseId}`, expenseData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update expense' };
    }
  },

  // Delete expense
  deleteExpense: async (expenseId) => {
    try {
      const response = await axios.delete(`${EXPENSE_URL}/${expenseId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete expense' };
    }
  },

  // Get all vendors
  getVendors: async () => {
    try {
      const response = await axios.get(`${LOV_URL}/lhvendors`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch vendors' };
    }
  },

  // Get expense items by subsidiary
  getExpenseItems: async (subsidiary) => {
    try {
      const response = await axios.get(`${LOV_URL}/lhexpenseitems/${subsidiary}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch expense items' };
    }
  },

  // Get payment types
  getPaymentTypes: async () => {
    try {
      const response = await axios.get(`${LOV_URL}/payment-types`, {
        headers: getAuthHeader(),
        params: { from_to: 'F' }
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch payment types' };
    }
  },

  // Get employees/users
  getEmployees: async () => {
    try {
      const response = await axios.get(`${LOV_URL}/lhusers`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch employees' };
    }
  },

  // Upsert TDS deduction
  upsertTdsDeduction: async (deductionData) => {
    try {
      const response = await axios.post(`${DEDUCTIONS_URL}/upsert-deduction`, deductionData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to save TDS deduction' };
    }
  }
};

export default expenseService;
